import React, { useState } from "react";
import { Breadcrumb, Col, Row } from "react-bootstrap";
import { FiServer, FiAlertOctagon, FiChevronsUp } from "react-icons/fi";
import { FiUsers, FiAlertCircle } from "react-icons/fi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { RiHome6Line } from "react-icons/ri";
import ITSystemCards from "../../../components/Dashboard/IT-admin-dashbaord/ITSystemCards";
import StorageUsageCard from "../../../components/Dashboard/IT-admin-dashbaord/StorageUsageCard";
import MFAUsersCard from "../../../components/Dashboard/IT-admin-dashbaord/MFAUsersCard";
import QuickActionsCard from "../../../components/Dashboard/IT-admin-dashbaord/QuickActionsCard";
import UserAccessManagement from "../../../components/Dashboard/IT-admin-dashbaord/UserAccessManagement";
import HRMSUsageTrend from "../../../components/Dashboard/IT-admin-dashbaord/HRMSUsageTrend";
import UserRolesDistribution from "../../../components/Dashboard/IT-admin-dashbaord/UserRolesDistribution";
import IntegrationErrors from "../../../components/Dashboard/IT-admin-dashbaord/IntegrationErrors";
const ITAdminDashboardPage = () => {
  const [activeTab, setActiveTab] = useState("Development");

  return (
    <>
  

      <div className="dashboard-header">

        <div className="header-flex">

          {/* LEFT CONTENT (UNCHANGED) */}

          <Col md={4} sm={12}>
            <div className="my-auto mb-2">

              <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>
                IT Admin Dashbaord
              </h4>

              <Breadcrumb
                style={{
                  background: "transparent",
                  padding: 0,
                  margin: 0,
                  fontSize: "14px",
                }}
              >

                <Breadcrumb.Item>
            <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        />
                </Breadcrumb.Item>

                <MdKeyboardArrowRight className="mt-1 fs-5" />

                <Breadcrumb.Item
                  linkAs="span"
                  className="text-dark text-decoration-none fs-6"
                >
                  Dashboard
                </Breadcrumb.Item>

                <MdKeyboardArrowRight className="mt-1 fs-5" />

                <Breadcrumb.Item active>
                  <span className="text-dark fs-6">
                    IT Admin Dashbaord
                  </span>
                </Breadcrumb.Item>

              </Breadcrumb>

            </div>
          </Col>

          {/* RIGHT CONTENT */}

          <div className="right-content">

            {/* ACTIVE USERS */}

      <div
      style={{
        display: "flex",
        gap: "12px",
        flexWrap: "wrap", // makes it responsive
      }}
    >
      {/* Active Users */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          background: "#fff",
          border: "1px solid #e5e7eb",
          borderRadius: "5px",
          padding: "2px 8px",
          minWidth: "200px",
          gap: "10px",
        }}
      >
        <div
          style={{
            background: "#22c55e",
            width: "36px",
            height: "36px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
          }}
        >
          <FiUsers size={18} />
        </div>

        <div
          style={{
            fontSize: "14px",
            color: "#6b7280",
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          Active Users
          <span
            style={{
              fontWeight: "600",
              color: "#111827",
              fontSize: "15px",
            }}
          >
            248
          </span>
        </div>
      </div>

      {/* Security Alerts */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          background: "#fff",
          border: "1px solid #e5e7eb",
          borderRadius: "5px",
          padding: "2px 8px",
          minWidth: "200px",
          gap: "10px",
        }}
      >
        <div
          style={{
            background: "#ef4444",
            width: "36px",
            height: "36px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
          }}
        >
          <FiAlertCircle size={18} />
        </div>

        <div
          style={{
            fontSize: "14px",
            color: "#6b7280",
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          Security Alerts
          <span
            style={{
              fontWeight: "600",
              color: "#111827",
              fontSize: "15px",
            }}
          >
            3
          </span>
        </div>
      </div>
    </div>

            {/* ENVIRONMENT TABS */}

            <div className="env-tabs">

              <button
                className={activeTab === "Production" ? "tab-btn active" : "tab-btn"}
                onClick={() => setActiveTab("Production")}
              >
                Production
              </button>

              <button
                className={activeTab === "Staging" ? "tab-btn active" : "tab-btn"}
                onClick={() => setActiveTab("Staging")}
              >
                Staging
              </button>

              <button
                className={activeTab === "Development" ? "tab-btn active" : "tab-btn"}
                onClick={() => setActiveTab("Development")}
              >
                Development
              </button>

            </div>

            {/* COLLAPSE BUTTON */}

            {/* <div className="collapse-btn">
              <FiChevronsUp />
            </div> */}

          </div>

        </div>

 <Row className="" >
  <ITSystemCards/>
 </Row>
  <Row className="g-4 mt-3">
      <Col xxl={8}>
        <StorageUsageCard/>
      </Col>

      <Col xxl={4}>
        <MFAUsersCard />
        <div className="mt-4">
          <QuickActionsCard />
        </div>
      </Col>
    </Row>
    
 <Row className="mt-3" >
 <UserAccessManagement/>
 </Row>

 <Row className="mt-3"  >
  <Col xl={6} lg={12}>
    <HRMSUsageTrend/> 
  </Col>

  <Col xl={6} lg={12} style={{ marginTop: "20px" }}>
    <UserRolesDistribution/>

    <div style={{ marginTop: "20px" }}>
      <IntegrationErrors/>
    </div>
  </Col>
</Row>
       <style>{`

      .dashboard-header{
        background:#f8f9fa;
        padding:16px 20px;
        border-bottom:1px solid #e5e7eb;
      }

      .header-flex{
        display:flex;
        justify-content:space-between;
        align-items:center;
        flex-wrap:wrap;
      }

      /* RIGHT SECTION */

      .right-content{
        display:flex;
        align-items:center;
        gap:14px;
        flex-wrap:wrap;
      }

      /* STATUS CARD */

      .status-card{
        display:flex;
        align-items:center;
        gap:10px;
        background:#f8fafc;
        border:1px solid #e5e7eb;
        padding:7px 14px;
        border-radius:8px;
      }

      .icon-box{
        width:32px;
        height:32px;
        display:flex;
        align-items:center;
        justify-content:center;
        border-radius:6px;
        color:#fff;
      }

      .icon-green{
        background:#22c55e;
      }

      .icon-red{
        background:#ef4444;
      }

      .status-text{
        font-size:14px;
        color:#475569;
      }

      .status-text span{
        font-weight:700;
        margin-left:5px;
        color:#0f172a;
      }

      /* TABS */

      .env-tabs{
        display:flex;
        background:#ffff;
        padding:3px;
        border-radius:5px;
      }

      .tab-btn{
        border:none;
        padding:6px 16px;
        font-size:14px;
        border-radius:6px;
        background:transparent;
        cursor:pointer;
        color:#0f172a;
      }

      .tab-btn.active{
        background:#f97316;
        color:#fff;
      }

      /* COLLAPSE BUTTON */

      .collapse-btn{
        width:34px;
        height:34px;
        border:1px solid #e5e7eb;
        border-radius:6px;
        display:flex;
        align-items:center;
        justify-content:center;
        cursor:pointer;
        background:#fff;
        color:#475569;
      }

      /* MOBILE */

      @media(max-width:768px){

        .header-flex{
          flex-direction:column;
          align-items:flex-start;
          gap:12px;
        }

        .right-content{
          width:100%;
          flex-wrap:wrap;
        }

        .env-tabs{
          width:100%;
          justify-content:space-between;
        }

      }

      `}</style>
      </div>
    </>
  );
};

export default ITAdminDashboardPage;